import Helpers from '../modules/Helpers'
import Reveal from '../modules/Reveal'

const headerSecondaryLinksIcon = document.getElementById('headerSecondaryLinksIcon')
const headerLinks = document.getElementById('headerLinks')

// Toggle header secondary navigation when clicking
// burger icon (only visible on small desktops).
new Helpers(headerSecondaryLinksIcon).eventListener((e) => {
    e.preventDefault()

    new Helpers(headerSecondaryLinksIcon).toggleClass('burger-icon--active')
    new Reveal(headerLinks).toggle('header__links--active')
})
